<template>
	<v-layout class="basket-full-screen">
		<v-flex class="basket-stepper-wrapper">
			<v-stepper class="basket-stepper" alt-labels v-model="activeStep">
				<v-stepper-header>
					<v-stepper-step step="1" @click="activeStep = 1" >{{ $t("shopComponents.gt3.fullBasket.recommendation") }}</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="2" @click="activeStep = 2">{{ $t("shopComponents.gt3.fullBasket.basket") }}</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="3">{{ $t("shopComponents.gt3.fullBasket.payment") }}</v-stepper-step>
				</v-stepper-header>
				<v-stepper-items>
					<v-stepper-content step="1">
						<v-flex>
							<v-flex class="recommended-content">
								<v-flex class="recommended-title">
									{{ $t("shopComponents.gt3.fullBasket.recommendedFavorites") }}
								</v-flex>
								<v-flex class="recommended-subtitle">
									{{ $t("shopComponents.gt3.fullBasket.tapToAdd") }}
								</v-flex>
								<v-layout row class="recommended-body mt-4">
									<upsell-rules
										@addToBasketClicked="() => $emit('getAddToBasket')"
										:onCloseDialog="() => {}"
										:menuProductsList="[]"
										:isBasketStepper="true"
									/>
								</v-layout>
							</v-flex>
						</v-flex>

					</v-stepper-content>

					<v-stepper-content step="2">
						<v-flex class="basket-content">
							<v-flex class="basket-title">
								{{ $t("shopComponents.gt3.fullBasket.weAreAlmost") }} <span class="color-secondary"> {{ $t("shopComponents.gt3.fullBasket.done") }}</span>
							</v-flex>
							<v-flex class="basket-subtitle">
								{{ $t("shopComponents.gt3.fullBasket.reviewYourOrder") }}
							</v-flex>
							<v-layout row class="mt-4 order-presentation-wrapper">
								<v-flex class="basket-order-header">
									<v-flex class="your-order">{{ $t("shopComponents.gt3.fullBasket.yourOrder") }}</v-flex>
									<v-flex class="cancel-order" @click="dialog = true">
										<span class="order-button-text"> {{ $t("shopComponents.gt3.fullBasket.cancelOrder") }} &nbsp&nbsp&nbsp</span>
										<v-icon>clear</v-icon>
									</v-flex>
								</v-flex>
								<order-presentation
									:cartProducts="cartProducts"
									:cartOrderTags="cartOrderTags"
									:productCatalog="productCatalog"
									:vouchersRedeemed="vouchersRedeemed"
									:globalSelectedShop="globalSelectedShop"
									:tenantSettings="tenantSettings"
									:isBasketStepper="true"
								/>
								<sunset-points-input
										v-if="featureToggles.enableSunsetPoints"
								/>
							</v-layout>
						</v-flex>
					</v-stepper-content>

					<v-stepper-content step="3">
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-flex>
		<v-flex class="bottom-section">
			<v-btn class="order-more" @click="goToCatalogPage()">{{ $t("shopComponents.gt3.fullBasket.orderMore") }}</v-btn>
			<v-flex v-if="activeStep === 2" class="basket-content-bottom">
				<div class="basket-content-voucher">
					<voucher-input
						v-if="!isAtLeastOneDiscountAppliedToCartSelection && (voucherVisible || isVoucher)"
						:cartProducts="cartProducts"
						:orderLines="orderLines"
						:vouchersRedeemed="vouchersRedeemed"
						:featureToggles="featureToggles"
						:globalSelectedShop="globalSelectedShop"
						:productCatalog="productCatalog"
						:voucherRef="voucherRef"
						@show-keyboard="showKeyboard"
						@hide-keyboard="hideKeyboard"
						:applyVoucherFromModal="applyVoucherFromModal"
					/>
					<v-btn
						v-if="isKiosk && (voucherVisible || isVoucher) && !isAtLeastOneDiscountAppliedToCartSelection"
						@click="showKeyboard"
						class="basket-transparent"
						primary
						flat
					>
						{{$t("utilityComponents.voucherInput.addVoucher")}}
					</v-btn>
				</div>
				<div class="ready-to-redeem-discounts" >
					<v-btn
						v-if="featureToggles.enableDiscountsPage && applicationUserLoggedIn && !isAtLeastOneDiscountAppliedToCartSelection"
						@click="isDiscountDialogShown = true"
						class="basket-transparent"
						primary
						flat>
						{{ $t('utilityComponents.productAsCompensationCRMModule.readyToRedeemDiscounts') }} ({{ getActiveVouchers }})
					</v-btn>
				</div>
				<div class="basket-total-price">{{ $t("shopComponents.gt3.fullBasket.total") }} {{formatPriceZero(totalPrice)}}</div>
			</v-flex>
			<v-btn class="go-to-checkout btn-secondary" @click="goToCheckoutPage()">{{ activeStep === 1 ? $t("shopComponents.gt3.fullBasket.firstStep") : $t("shopComponents.gt3.fullBasket.goToPayment") }}</v-btn>
		</v-flex>
		<v-dialog
			v-model="isKeyboardShown"
			v-if="isKeyboardShown"
			:content-class="`keyboard-dialog`"
		>
			<v-layout column class="kiosk-modal keyboard-layout">
				<div>
					<v-btn icon class="close-btn" @click="isKeyboardShown = false">
						<img  alt="" class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
					</v-btn>
					<v-layout class="keyboard-dialog-title">
						{{$t("utilityComponents.voucherInput.insertYourCode")}}
					</v-layout>
					<v-layout class="keyboard-dialog-body">
						<v-text-field
							ref="voucherModalInput"
							type="text"
							class="voucher-modal-input"
							v-model="voucherRef"
							required
						></v-text-field>
						<keyboard-input
							v-if="voucherVisible && isKeyboardShown"
							:get-image="getImage('delete-number-icon.svg')"
							:keyboard-characters="keyboardCharacters"
							:show-additional-buttons="true"
							@insert-number="insertNumber"
							@delete-last-digit="deleteLastDigit"
							@hide-keyboard="hideKeyboard"
							class="keyboard"
						/>
						<v-btn class="green-btn keyboard-dialog-btn" @click="applyVoucher">
							{{$t("utilityComponents.voucherInput.approve")}}
						</v-btn>
						<v-layout class="keyboard-description">
							{{$t("utilityComponents.voucherInput.insertCodeDescription")}}
						</v-layout>
					</v-layout>
				</div>
			</v-layout>
		</v-dialog>
		<v-dialog
			v-model="dialog"
			content-class="cancel-order-modal">
			<v-card>
				<v-card-title>
					<div class="popup-wrapper">
						<v-container>
							<v-flex xs12 class="close-image">
								<img class="delivery-image" :src=deliveryChoice.href.white>
								<div class="popup-title">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupMessage")}}</div>
								<div class="popup-subtitle">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupSubtitle")}} </div>
							</v-flex>
							<v-flex>
								<div class="buttons-wrapper">
									<v-card-actions>
										<v-btn
											class="back-btn"
											@click="dialog = false"
										>
											{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.back")}}
										</v-btn>

										<v-btn
											class="quit-btn"
											@click="clearBasket()"
										>
											{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.interrupt")}}
										</v-btn>
									</v-card-actions>
								</div>
							</v-flex>
						</v-container>
						<div class="close-btn" @click="dialog=false"></div>
					</div>
				</v-card-title>
			</v-card>
		</v-dialog>
		<restart-app-dialog
			:modal-component-shown="idleDialog"
			:dialogTime="dialogTime"
			:closeCallback="stayOnPage"
		/>
		<v-dialog
			v-model="isDiscountDialogShown"
			v-if="isDiscountDialogShown"
			:content-class="`discount-dialog`"
		>
			<v-layout column class="kiosk-modal discount-layout">
				<div>
					<img :src="getImage('arrow-left.png')" class="arrow-size-fix" :alt="$t('common.back')" @click="isDiscountDialogShown = false"/>
					<discount :sideMenuDiscount="true" :onClose="() => isDiscountDialogShown = false"/>
				</div>
			</v-layout>
		</v-dialog>
	</v-layout>
</template>

<script>
import RecommendationEngineProvider from "../../../../providers/RecommendationEngineProvider";

const {Formats: timeBoxFormats, timebox: timeBox} = appConfig.timeBoxImpl;
const tenantConfig = appConfig.tenantConfig;
import * as Utils from "../../../../libraries/utils";
import {prepareGTMeCommerceData} from "../../../../integrations/tracking/gtm/gtmHelper";
import {pushGTMeCommerceData} from "../../../../integrations/tracking/gtm/pushGTMeCommerceData";
import {mapGetters} from "vuex";
import UpsellRules from "../../../GlobalSharedComponents/Shop/UpsellRules.vue";
import OrderPresentation from "./OrderPresentation-gt3.vue";
import {formatPriceZero} from "../../../../domains2/libraries/Utils";
import protectOrderFlowMixin from "../../../../mixins/protectOrderFlow.mixin";
import mysteryBoxMixin from "../../../../mixins/mysteryBox.mixin";
import OrderItemCommonMixin from "../../../../mixins/OrderItemCommon.mixin";
import kioskIdleTimeoutMixin from "../../../../mixins/kioskIdleTimeout.mixin";
import voucherAwardMixin from "../../../../mixins/voucherReward/voucherAward.mixin";
import productSelectionMixin from "../../../../mixins/productSelection.mixin";
import pricesMixin from "../../../../mixins/prices.mixin";
import dealsMixin from "../../../../mixins/deals.mixin";
import productCatalogMenuMixin from "../../../../mixins/productCatalogMenu.mixin";
import KeyboardInput from "../../../UtilityComponents/KeyboardInput.vue";
import Discount from "../../gt2/Discount/Discount.vue";
import RestartAppDialog from "../RestartAppDialog-gt3.vue";
import MysteryBox from "../../../UtilityComponents/MysteryBox.vue";
import SunsetPointsInput from "../../../UtilityComponents/SunsetPointsInput.vue";
import VoucherInput from "../../../UtilityComponents/VoucherInput.vue";
import UpgradeDealToMenuDialog from "../../gt2/Dialogs/UpgradeDealToMenuDialog.vue";
import appConfig, {channelEnum} from "../../../../appconfig";
import * as mutationTypes from "../../../../store/mutation-types";
import {DeliveryMethodsEnum} from "../../../../domains2/libraries/DeliveryMethods";

export default {
	name: "BasketFullScreen",
	components: {
		Discount,
		RestartAppDialog,
		MysteryBox,
		SunsetPointsInput,
		VoucherInput,
		KeyboardInput,
		OrderPresentation,
		UpgradeDealToMenuDialog,
		UpsellRules
	},
	props: ["isVoucher"],
	data() {
		return {
			activeStep: 1,
			voucherRef: "",
			keyboardCharacters: [
				["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
				["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
				["A", "S", "D", "F", "G", "H", "J", "K", "L", "."],
				["Z", "X", "C", "V", "B", "N", "M"]
			],
			isKeyboardShown: false,
			applyVoucherFromModal: false,
			dialog: false,
			isDiscountDialogShown: false
		};
	},
	mixins: [
		protectOrderFlowMixin,
		mysteryBoxMixin,
		OrderItemCommonMixin,
		kioskIdleTimeoutMixin,
		voucherAwardMixin,
		productSelectionMixin,
		pricesMixin,
		dealsMixin,
		productCatalogMenuMixin
	],
	async mounted() {
		this.getVouchersData();
		setTimeout(() => {
			if(this.$store.getters.newBasketStepperToTableServingFlag) {
				this.activeStep = 2;
				this.$store.commit("SET_NEW_BASKET_STEPPER_TO_TABLE_SERVING_FLAG", false);
			}
		});
		this.resetTimer();
		this.idleTimer();
	},
	computed: {
		...mapGetters([
			"cartProducts",
			"tenantSpecificData",
			"featureToggles",
			"productCatalog",
			"tenantSettings",
			"globalSelectedShop",
			"cartOrderTags",
			"vouchersRedeemed",
			"totalPrice",
			"orderLines"
		]),
		isKiosk() {
			return appConfig.channelAlias() === channelEnum.kiosk;
		},
		channel() {
			return appConfig.channelAlias();
		},
		deliveryChoice() {
			const self = this;
			const channelFolder = self.channel === "desktopBrowser" ? "desktop" : self.channel;
			const deliveryChoices = [
				{
					id: 0,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.eatIn.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-white.svg`
					}
				},
				{
					id: 1,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.parkingPickup.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-white.svg`
					}
				},
				{
					id: 2,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.takeOut.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 3,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.delivery.desktopBrowser`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 4,
					title: self.$t(`shopComponents.gt3.shoppingCart_steps.shoppingCartStepDeliveryMethod.shoppingCartStepBoothNumber.driveThrough`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 5,
					title: self.$t(`common.deliveryMethods.DRIVE_THROUGH`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				}
			];
			return deliveryChoices.find(item => item.id === self.tenantSpecificData.deliveryChoice);
		},
		voucherVisible() {
			return this.featureToggles.voucherEnabled;
		},
		shouldRouteToTableServing() {
			const eatInChosen = this.tenantSpecificData.deliveryChoice === DeliveryMethodsEnum.EAT_IN;
			const takeAwayChosen = this.tenantSpecificData.deliveryChoice === DeliveryMethodsEnum.TAKE_OUT;
			return (
				tenantConfig.tableServing &&
				this.globalSelectedShop.shopOptions.tableServing &&
				eatInChosen
			) || (
				this.channel === "kiosk" &&
				this.globalSelectedShop.shopOptions.enableBeeperDeviceFeature &&
				takeAwayChosen
			);
		},
		getActiveVouchers () {
			return this.getVouchersData().filter(item => !item.usedAt).length;
		}
	},
	methods: {
		formatPriceZero,
		getImage(imageName) {
			return Utils.getMiscImageUrl(imageName);
		},
		goToHomePage() {
			this.$router.push("/");
		},
		applyVoucher() {
			this.isKeyboardShown = false;
			this.applyVoucherFromModal = true;
		},
		hideKeyboard() {
			this.isKeyboardShown = false;
			this.voucherRef = "";
		},
		deleteLastDigit() {
			if(this.voucherRef.length === 1) {
				this.voucherRef = "";
			} else {
				this.voucherRef = this.voucherRef.toString().slice(0, -1);
			}
		},
		insertNumber(number) {
			this.voucherRef = this.voucherRef.toString().concat(number.toString());
		},
		goToCatalogPage() {
			const firstCategoryId = Utils.getCategoriesByShopId(this.globalSelectedShop.id, this.productCatalog)[0].extId;
			this.$router.push(`/category/${firstCategoryId}`);
		},
		async goToCheckoutPage() {
			if(this.activeStep === 2) {
				await this.goToCheckout();
			} else {
				this.activeStep += 1;
			}
		},
		showKeyboard() {
			this.isKeyboardShown = true;
			this.applyVoucherFromModal = false;
			setTimeout(() => {
				const voucherInput = this.$refs.voucherModalInput;
				if(voucherInput) {
					voucherInput.focus();
				}
			}, 0);
		},
		async setPickupData() {
			const self = this;
			await self.$store.dispatch(mutationTypes.CART_SET_PICKUP_DATA, {
				pickupDate: timeBox.now().format(timeBoxFormats.YYYY_MM_DD).exec(),
				pickupTime: "ASAP",
				submitted: true
			});
			await self.$store.commit(mutationTypes.SET_ASAP_PICKUP, true);
		},
		async sendOrder() {
			const self = this;
			self.sendingOrder = true;

			const baseUrl = window.location.origin;
			const urlAccept = `${baseUrl}/payment/accept`;
			const urlCancel = `${baseUrl}/payment/cancel`;
			self.$store.dispatch(mutationTypes.CART_INITIALIZE_PAYMENT, {
				urlAccept: urlAccept,
				urlCancel: urlCancel
			}).then(async data => {
				const zeroPaymentPath = `/payment/zero?orderNumber=${data.orderNumber}`;
				if (data.payment.paymentType === "zeroPayment") {
					self.sendingOrder = false;
					self.$router.push(zeroPaymentPath);
				} else {
					self.sendingOrder = false;
					if (self.featureToggles.verticalKioskPayment) {
						await self.$router.push("/checkout");
					} else {
						window.location.replace(data.payment.redirectUrl);
					}
				}
			}).catch((err) => {
				self.sendingOrder = false;
				throw err;
			});
		},
		async goToCheckout() {
			const data = prepareGTMeCommerceData();
			pushGTMeCommerceData({
				eventName: "begin_checkout",
				products: data.items,
				value: data.value
			});
			if(await this.getMysteryBoxProduct()) {
				return;
			}
			const self = this;
			if (appConfig.channelAlias() === "desktopBrowser") {
				this.pushGTMInternal("Checkout", "visit", "Init");
				self.$router.push("/checkout");
			} else {
				self.sendingOrder = true;
				await self.setPickupData();
				if (self.getPaymentFlowType === "web") {
					if (self.featureToggles.verticalKioskBasket && self.styleVariant === "a" && self.preCheckout) {
						self.$router.push({ name: "pre-checkout" });
					} else
					if (this.shouldRouteToTableServing) {
						self.$store.commit("SET_NEW_BASKET_STEPPER_TO_TABLE_SERVING_FLAG", true);
						self.$router.push("/table-serving");
					} else {
						await self.sendOrder();
					}
				} else {
					if (this.shouldRouteToTableServing) {
						self.$store.commit("SET_NEW_BASKET_STEPPER_TO_TABLE_SERVING_FLAG", true);
						self.$router.push("/table-serving");
					} else {
						self.$router.push("/checkout");
					}
				}
			}
			if(this.featureToggles.enableRcmProductBadges && this.$store.getters.rcmProductBadgesFeedbackData.recommendations.length) {
				RecommendationEngineProvider.sendFeedbackBadges(
					{
						recommendations: this.$store.getters.rcmProductBadgesFeedbackData.recommendations,
						picks: this.$store.getters.rcmProductBadgesFeedbackData.picks,
						experimentId: `${this.$store.getters.rcmProductBadgesFeedbackData.experimentId}`,
						channel: this.channel,
						shopName: this.globalSelectedShop.shopNameAlias
					},
					appConfig.tenantId
				);
				this.$store.commit(mutationTypes.SET_RCM_PRODUCT_BADGES_PICKS);
			}
		}
	}
};
</script>

<style scoped lang="scss">
.basket-full-screen {
	width: 100%;
	height: 100vh;
	color: #FFFFFF;
	position: relative;
	z-index: 2;
	background-color: #000000;
	overflow: hidden;
	.basket-stepper-wrapper {
		margin: 50px 500px;
		/deep/ .v-stepper.basket-stepper.v-stepper--alt-labels {
			background-color: #000000;
			.v-stepper__header {
				.v-divider {
					border-color: #979797;
				}
			}
			.v-stepper__step {
				.v-stepper__label {
					color: #979797;
					font-size: 16px;
					line-height: 1;
				}
				.v-stepper__step__step {
					color: #000000;
					background-color: #979797;
				}
				&.v-stepper__step--active {
					.v-stepper__label {
						color: #FED700;
					}
					.v-stepper__step__step.primary {
						background-color: #FED700 !important;
						border-color: #FED700 !important;
					}
				}
			}
			.v-stepper__content {
				.recommended-content {
					.recommended-title {
						font-size: 40px;
						line-height: 50px;
						font-weight: 700;
						text-align: center;
					}
					.recommended-subtitle {
						font-size: 20px;
						text-align: center;
						padding-top: 24px;
					}
					.recommended-body {
						height: calc(100vh - 410px);
						overflow: auto;
					}
					.upsell-rules-container {
						width: 100%;
						padding: 0;
						.container {
							padding: 0;
							.product {
								display: flex;
								flex-direction: row;
								align-items: flex-end;
								justify-content: space-between;
								padding: 12px;
								.product-name {
									margin-bottom: 0;
									margin-right: 10px;
								}
							}
						}
					}
				}
				.basket-content {
					.basket-title {
						font-size: 40px;
						line-height: 50px;
						font-weight: 700;
						text-align: center;
					}
					.basket-subtitle {
						font-size: 20px;
						text-align: center;
						padding-top: 24px;
					}
					.basket-order-header {
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-bottom: 10px;
						flex: 0 1 auto;
						.your-order {
							color: #212B36;
							font-size: 18px;
							line-height: 1;
							font-weight: 700;
							text-transform: uppercase;
						}
						.order-button-text {
							color: #979797;
							font-size: 14px;
							line-height: 1;
						}
						.cancel-order {
							display: flex;
							align-items: center;
							justify-content: flex-end;
						}
					}
					.sunset-points {
						position: absolute;
						left: unset;
						right: unset;
						margin: 0;
						bottom: 24px;
						z-index: 1;
						width: calc(100% - 80px);
						color: #000000;
					}
					.order-discount {
						padding: 0 16px;
					}
				}
			}
		}
	}
	.bottom-section {
		position: absolute;
		bottom: 0;
		width: 100%;
		.v-btn {
			position: absolute;
			bottom: 20px;
			width: 363px !important;
			height: 56px;
			text-transform: none;
			&.order-more {
				left: 20px;
				margin: 0;
				background-color: #ffd800;
				border: 2px solid #ffd800;
				color: #000000;
			}
			&.go-to-checkout {
				right: 20px;
			}
		}
		.basket-transparent {
			border: 2px solid #FFFFFF;
			color: #FFFFFF;
			position: relative;
			bottom: 0;
		}
		.basket-content-bottom {
			display: flex;
			justify-content: space-between;
			margin: 0 500px;
			padding-bottom: 20px;
			align-items: center;
			position: relative;
			/deep/ .voucher-message {
				top: -50px;
				right: 0;
				left: unset;
				width: 50%;
			}
			.ready-to-redeem-discounts {
				/deep/ .v-btn {
					.v-btn__content {
						white-space: normal;
						line-height: 1;
					}
				}
			}
		}
		.basket-total-price {
			font-size: 20px;
			font-weight: 700;
		}
	}
}
.v-dialog.keyboard-dialog {
	.keyboard-layout {
		background-image: none;
		margin-top: 50px;

		.close-btn {
			width: 80px;
			height: 80px;
			border-color: #FFFFFF;
			top: 132px !important;
			right: -10px;
			z-index: 1;
		}
	}

	.keyboard-dialog-title {
		display: flex;
		justify-content: center;
		font-size: 40px;
		padding-bottom: 30px;
	}

	.voucher-modal-input {
		padding: 0;
		margin-bottom: 4px;
		caret-color: #FFFFFF !important;

		/deep/ .v-input__slot {
			//background-color: #171618;
			background-color: #404040;
			height: 70px;
			margin-bottom: 0;

			input {
				max-height: 60px;
				height: 60px;
				font-size: 40px;
				text-align: center;
				color: white;
			}

			&:after {
				border-color: #171618;
			}
		}

		/deep/ .v-text-field__details {
			display: none;
		}

	}

	.keyboard-dialog-body {
		display: flex;
		flex-direction: column;
	}

	.keyboard-dialog-btn {
		height: 70px;
		font-size: 28px;
		text-transform: none;
		margin-top: 4px;
	}

	.keyboard-description {
		justify-content: center;
		padding-top: 30px;
		font-size: 16px;
	}
}
.v-card__title{
	padding: 0;
	background-color: #000000;
	.container{
		width: 722px;
		height: 423px;
		border-radius: 5px;
		box-shadow: 0 0 50px 20px rgba(72, 72, 72, 0.23);
		border: solid 3px #26282c;
		background-color: #000000;
		color: #FFFFFF;
		padding: 0;
		.v-card__actions{
			justify-content: center;
			padding-top: 40px;
			.v-btn{
				width: 220px !important;
				height: 50px;
			}
			.back-btn{
				border-radius: 3px;
				border: solid 2px #ffffff;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				background-color: transparent;
			}
			.quit-btn{
				border-radius: 3px;
				border: solid 2px #ffd800;
				background-color: #ffd800;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #000000;
				margin-left: 16px;
			}
		}
		.close-image{
			margin-top: 60px;
			text-align: center;
			justify-content: center;
			.delivery-image{
				width: 112px;
				height: 103px;
			}
			.popup-title{
				font-family: Dispatch;
				font-size: 24px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				text-transform: uppercase;
				margin-top: 21px;
				margin-bottom: 16px;
			}
			.popup-subtitle{
				font-family: Dispatch;
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				margin: auto;
				padding: 0 15px;
			}
		}
	}
}
/deep/ .v-dialog.discount-dialog {
	height: 100vh;
	background-color: black;
	margin: 0 0 0 auto;
	flex-basis: 27%;
	width: 27%;
	border-left: 3px solid #464646;
	overflow: auto;
	.layout.kiosk-modal.discount-layout {
		background-image: none;
		.v-btn.btn-color {
			color: #ffffff;
			width: auto;
		}
	}
	.discount-title.discount-title-desktop {
		text-transform: uppercase;
		font-size: 21px;
		text-align: center;
		padding-bottom: 20px;
		font-weight: normal;
	}
}
</style>
